<form [formGroup]="formGroup" id="step4Form">
  <div class="step4-form-container">
    <div class="row">
      <div
        *ngIf="controls.inPolandAtApplicationSubmition as inPolandAtApplicationSubmition"
        class="standard-form-field radio-form-field inPolandAtApplicationSubmition-field required-field">
        <label
          id="applicantInPolandAtApplicationSubmitionLabel"
          [class.invalid]="inPolandAtApplicationSubmition.touched && inPolandAtApplicationSubmition.invalid">
          {{ 'IN_POLAND_AT_APPLICATION_SUBMITION.INFIELD-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>

          <!-- TOOLTIP -->
          <app-cr-form-field-tooltip
            [id]="'applicantInPolandAtApplicationSubmitionTooltip'"
            aria-labelledby="applicantInPolandAtApplicationSubmitionLabel"
            class="info-suffix-icon"
            matSuffix
            [text]="'IN_POLAND_AT_APPLICATION_SUBMITION.TOOLTIP' | translate">
          </app-cr-form-field-tooltip>
        </label>
        <mat-radio-group
          id="applicantInPolandAtApplicationSubmition"
          formControlName="inPolandAtApplicationSubmition"
          (keydown)="firstInputKeydown($event)"
          [required]="true"
          [attr.aria-invalid]="
            inPolandAtApplicationSubmition.touched && inPolandAtApplicationSubmition.invalid ? 'true' : null
          ">
          <mat-radio-button [value]="true" id="inPolandAtApplicationSubmition-0">
            {{ 'COMMON.GENERAL.YES' | translate }}
          </mat-radio-button>
          <mat-radio-button [value]="false" id="inPolandAtApplicationSubmition-1">
            {{ 'COMMON.GENERAL.NO' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div class="row" *ngIf="controls.inPolandAtApplicationSubmition.value === true">
      <div
        *ngIf="controls.currentlyLivingInPoland as currentlyLivingInPoland"
        class="standard-form-field radio-form-field currentlyLivingInPoland-field required-field">
        <label
          id="applicantCurrentlyLivingInPolandLabel"
          [class.invalid]="currentlyLivingInPoland.touched && currentlyLivingInPoland.invalid">
          {{ 'PERSONAL_DATA_FORM.RESIDENCE-CURRENTLY-LIVING-IN-POLAND.INFIELD-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-radio-group
          id="applicantCurrentlyLivingInPoland"
          aria-labelledby="applicantCurrentlyLivingInPolandLabel"
          formControlName="currentlyLivingInPoland"
          (keydown)="firstInputKeydown($event)"
          [attr.aria-invalid]="currentlyLivingInPoland.touched && currentlyLivingInPoland.invalid ? 'true' : null">
          <mat-radio-button [value]="true" id="applicantCurrentlyLivingInPoland-0">
            {{ 'COMMON.GENERAL.YES' | translate }}
          </mat-radio-button>
          <mat-radio-button [value]="false" id="applicantCurrentlyLivingInPoland-1">
            {{ 'COMMON.GENERAL.NO' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <ng-container
      *ngIf="
        controls.inPolandAtApplicationSubmition.value === true &&
        (controls.currentlyLivingInPoland.value === true || controls.currentlyLivingInPoland.value === false)
      ">
      <div class="row">
        <div
          *ngIf="controls.legalBasisOfStay as legalBasisOfStay"
          class="standard-form-field widened-field legalBasisOfStay-field required-field">
          <label
            id="applicantLegalBasisOfStayLabel"
            [class.invalid]="legalBasisOfStay.touched && legalBasisOfStay.invalid">
            {{
              controls.currentlyLivingInPoland.value === true
                ? ('PERSONAL_DATA_FORM.LEGAL-BASIS-OF-STAY.MAIN-LABEL' | translate)
                : ('PERSONAL_DATA_FORM.PLANNED-LEGAL-BASIS-OF-STAY.MAIN-LABEL' | translate)
            }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>

          <mat-form-field appearance="outline">
            <mat-select
              id="applicantLegalBasisOfStay"
              panelClass="standard-select"
              placeholder="{{
                controls.currentlyLivingInPoland.value === true
                  ? ('PERSONAL_DATA_FORM.LEGAL-BASIS-OF-STAY.PLACEHOLDER' | translate)
                  : ('PERSONAL_DATA_FORM.PLANNED-LEGAL-BASIS-OF-STAY.PLACEHOLDER' | translate)
              }}"
              formControlName="legalBasisOfStay"
              [attr.aria-required]="true"
              [attr.aria-labelledby]="'applicantLegalBasisOfStayLabel'"
              [attr.aria-invalid]="legalBasisOfStay.touched && legalBasisOfStay.invalid ? 'true' : null"
              [attr.aria-describedby]="
                legalBasisOfStay.touched && legalBasisOfStay.invalid ? 'legalBasisOfStayError' : null
              ">
              <mat-option *ngFor="let item of legalBasisOfStayList.longResi" [value]="item.value">
                {{ 'SELECTS_VALUES.STAY_LEGAL_BASIS_NEW.' + item.labelKey | translate }}
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error id="legalBasisOfStayError" *ngIf="legalBasisOfStay.touched && legalBasisOfStay.invalid">
              {{ legalBasisOfStay.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div
          *ngIf="controls.residenceVisaExpiryDate as residenceVisaExpiryDate"
          class="standard-form-field residenceVisaExpiryDate-field required-field">
          <label
            for="applicantResidenceVisaExpiryDatePickerNoCurrentlyInRP"
            [class.invalid]="
              (residenceVisaExpiryDate.touched && residenceVisaExpiryDate.invalid) ||
              formGroup.errors?.visaExpiredBeforeLastEntryDate
            ">
            {{ 'PERSONAL_DATA_FORM.RESIDENCE-VISA-EXPIRY-DATE.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline" (click)="residenceVisaExpiryDatePicker.open()">
            <input
              matInput
              id="applicantResidenceVisaExpiryDatePickerNoCurrentlyInRP"
              #applicantResidenceVisaExpiryDatePicker
              readonly
              (focus)="residenceVisaExpiryDatePicker.open()"
              [matDatepicker]="residenceVisaExpiryDatePicker"
              [min]="currentDate"
              [max]="maxValidDocumentExpiryDate"
              placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-VISA-EXPIRY-DATE.PLACEHOLDER' | translate }}"
              formControlName="residenceVisaExpiryDate"
              [attr.aria-required]="true"
              [attr.aria-invalid]="residenceVisaExpiryDate.touched && residenceVisaExpiryDate.invalid ? 'true' : null"
              [attr.aria-describedby]="
                residenceVisaExpiryDate.touched && residenceVisaExpiryDate.invalid
                  ? 'residenceVisaExpiryDateError'
                  : null
              " />

            <mat-datepicker-toggle
              matSuffix
              [for]="residenceVisaExpiryDatePicker"
              aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
            </mat-datepicker-toggle>

            <mat-datepicker
              #residenceVisaExpiryDatePicker
              [startView]="'month'"
              [startAt]="currentDate"
              [calendarHeaderComponent]="pickerHeader"
              (closed)="applicantResidenceVisaExpiryDatePicker.blur()">
            </mat-datepicker>

            <!-- ERROR -->
            <mat-error
              id="residenceVisaExpiryDateError"
              *ngIf="residenceVisaExpiryDate.touched && residenceVisaExpiryDate.invalid">
              {{ residenceVisaExpiryDate.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div
          *ngIf="controls.lastEntryDate as lastEntryDate"
          class="standard-form-field widened-field lastEntryDate-field required-field">
          <label for="applicantLastEntryDate" [class.invalid]="lastEntryDate.touched && lastEntryDate.invalid">
            {{
              controls.currentlyLivingInPoland.value === true
                ? ('PERSONAL_DATA_FORM.LAST-ENTRY-DATE.MAIN-LABEL' | translate)
                : ('PERSONAL_DATA_FORM.PLANNED-ENTRY-DATE.MAIN-LABEL' | translate)
            }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline" (click)="lastEntryDatePicker.open()">
            <input
              matInput
              id="applicantLastEntryDate"
              #applicantLastEntryDate
              readonly
              (focus)="lastEntryDatePicker.open()"
              [matDatepicker]="lastEntryDatePicker"
              placeholder="{{ 'PERSONAL_DATA_FORM.LAST-ENTRY-DATE.PLACEHOLDER' | translate }}"
              [min]="controls.currentlyLivingInPoland.value === true ? null : currentDate"
              [max]="controls.currentlyLivingInPoland.value === true ? currentDate : null"
              formControlName="lastEntryDate"
              [attr.aria-required]="true"
              [attr.aria-invalid]="lastEntryDate.touched && lastEntryDate.invalid ? 'true' : null"
              [attr.aria-describedby]="lastEntryDate.touched && lastEntryDate.invalid ? 'lastEntryDateEntry' : null" />

            <mat-datepicker-toggle
              matSuffix
              [for]="lastEntryDatePicker"
              aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
            </mat-datepicker-toggle>

            <mat-datepicker
              #lastEntryDatePicker
              [startAt]="currentDate"
              [startView]="'month'"
              [calendarHeaderComponent]="pickerHeader"
              (closed)="applicantLastEntryDate.blur()">
            </mat-datepicker>

            <!-- ERROR -->
            <mat-error id="lastEntryDateEntry" *ngIf="lastEntryDate.touched && lastEntryDate.invalid">
              {{ lastEntryDate.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>

          <!-- ERROR -->
          <mat-error *ngIf="formGroup.errors?.VISA_EXPIRED_BEFORE_LAST_ENTRY_DATE">
            {{ 'COMMON.VALIDATOR.VISA_EXPIRED_BEFORE_LAST_ENTRY_DATE' | translate }}
          </mat-error>
        </div>
      </div>

      <div class="row">
        <div
          *ngIf="controls.purposeOfStay as purposeOfStay"
          class="standard-form-field widened-field purposeOfStay-field required-field">
          <label for="purposeOfStayInput" [class.invalid]="purposeOfStay.touched && purposeOfStay.invalid">
            {{ 'PERSONAL_DATA_FORM.PURPOSE-OF-STAY.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <mat-select
              id="purposeOfStayInput"
              panelClass="standard-select"
              placeholder="{{ 'PERSONAL_DATA_FORM.PURPOSE-OF-STAY.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="purposeOfStay.touched && purposeOfStay.invalid ? 'true' : null"
              [attr.aria-describedby]="purposeOfStay.touched && purposeOfStay.invalid ? 'purposeOfStayError' : null"
              formControlName="purposeOfStay">
              <mat-option *ngFor="let item of purposeOfStayList" [value]="item">
                {{ 'PROCESSES.ORIG_PROCESSES.' + item | translate }}
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error id="purposeOfStayError" *ngIf="purposeOfStay.touched && purposeOfStay.invalid">
              {{ purposeOfStay.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <ng-container *ngIf="controls.legalBasisOfStay.value === 'VISA'">
        <div class="row">
          <div
            *ngIf="controls.stayVisaType as stayVisaType"
            class="standard-form-field widened-field stayVisaType-field required-field">
            <label for="stayVisaTypeInput" [class.invalid]="stayVisaType.touched && stayVisaType.invalid">
              {{ 'PERSONAL_DATA_FORM.STAY-VISA-TYPE.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <mat-select
                id="stayVisaTypeInput"
                panelClass="standard-select"
                formControlName="stayVisaType"
                placeholder="{{ 'PERSONAL_DATA_FORM.STAY-VISA-TYPE.PLACEHOLDER' | translate }}"
                [attr.aria-required]="true"
                [attr.aria-invalid]="stayVisaType.touched && stayVisaType.invalid ? 'true' : null"
                [attr.aria-describedby]="stayVisaType.touched && stayVisaType.invalid ? 'stayVisaTypeError' : null">
                <mat-option *ngFor="let item of visaTypes" [value]="item">
                  {{ 'COMMON.VISA_TYPES.' + item | translate }}
                </mat-option>
              </mat-select>

              <!-- ERROR -->
              <mat-error id="stayVisaTypeError" *ngIf="stayVisaType.touched && stayVisaType.invalid">
                {{ stayVisaType.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div
            *ngIf="controls.stayVisaSeries as stayVisaSeries"
            class="standard-form-field stayVisaSeries-field required-field">
            <label for="stayVisaSeriesInput" [class.invalid]="stayVisaSeries.touched && stayVisaSeries.invalid">
              {{ 'PERSONAL_DATA_FORM.STAY-VISA-SERIES.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="stayVisaSeriesInput"
                type="text"
                minLength="1"
                maxLength="2"
                placeholder="{{ 'PERSONAL_DATA_FORM.STAY-VISA-SERIES.PLACEHOLDER' | translate }}"
                [formControl]="stayVisaSeries"
                [attr.aria-required]="true"
                [attr.aria-invalid]="stayVisaSeries.touched && stayVisaSeries.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  stayVisaSeries.touched && stayVisaSeries.invalid ? 'stayVisaSeriesError' : null
                " />

              <!-- ERROR -->
              <mat-error id="stayVisaSeriesError" *ngIf="stayVisaSeries.touched && stayVisaSeries.invalid">
                {{ stayVisaSeries.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div
            *ngIf="controls.stayVisaNumber as stayVisaNumber"
            class="standard-form-field stayVisaNumber-field required-field">
            <label for="stayVisaNumberInput" [class.invalid]="stayVisaNumber.touched && stayVisaNumber.invalid">
              {{ 'PERSONAL_DATA_FORM.STAY-VISA-NUMBER.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="stayVisaNumberInput"
                type="string"
                minlength="1"
                maxlength="10"
                placeholder="{{ 'PERSONAL_DATA_FORM.STAY-VISA-NUMBER.PLACEHOLDER' | translate }}"
                [formControl]="stayVisaNumber"
                [attr.aria-required]="true"
                [attr.aria-invalid]="stayVisaNumber.touched && stayVisaNumber.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  stayVisaNumber.touched && stayVisaNumber.invalid ? 'stayVisaNumberError' : null
                " />

              <!-- ERROR -->
              <mat-error id="stayVisaNumberError" *ngIf="stayVisaNumber.touched && stayVisaNumber.invalid">
                {{ stayVisaNumber.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div
            *ngIf="controls.stayVisaIssueDate as stayVisaIssueDate"
            class="standard-form-field stayVisaIssueDate-field required-field">
            <label
              for="stayVisaIssueDateInput"
              [class.invalid]="stayVisaIssueDate.touched && stayVisaIssueDate.invalid">
              {{ 'PERSONAL_DATA_FORM.STAY-VISA-ISSUE-DATE.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline" (click)="stayVisaIssueDatePicker.open()">
              <input
                matInput
                (focus)="stayVisaIssueDatePicker.open()"
                id="stayVisaIssueDateInput"
                #applicantStayVisaIssueDate
                [matDatepicker]="stayVisaIssueDatePicker"
                placeholder="{{ 'PERSONAL_DATA_FORM.STAY-VISA-ISSUE-DATE.PLACEHOLDER' | translate }}"
                [min]="minValidDate"
                [max]="maxValidDate"
                [readonly]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="stayVisaIssueDate.touched && stayVisaIssueDate.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  stayVisaIssueDate.touched && stayVisaIssueDate.invalid ? 'stayVisaIssueDateError' : null
                "
                [formControl]="stayVisaIssueDate" />

              <mat-datepicker-toggle
                matSuffix
                [for]="stayVisaIssueDatePicker"
                aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
              </mat-datepicker-toggle>

              <mat-datepicker
                #stayVisaIssueDatePicker
                [startView]="'month'"
                [startAt]="'1985'"
                [calendarHeaderComponent]="pickerHeader"
                (closed)="applicantStayVisaIssueDate.blur()">
              </mat-datepicker>

              <!-- ERROR -->
              <mat-error id="stayVisaIssueDateError" *ngIf="stayVisaIssueDate.touched && stayVisaIssueDate.invalid">
                {{ stayVisaIssueDate.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div
            *ngIf="controls.stayVisaExpiryDate as stayVisaExpiryDate"
            class="standard-form-field stayVisaExpiryDate-field required-field">
            <label
              for="stayVisaExpiryDateInput"
              [class.invalid]="stayVisaExpiryDate.touched && stayVisaExpiryDate.invalid">
              {{ 'PERSONAL_DATA_FORM.STAY-VISA-EXPIRY-DATE.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline" (click)="stayVisaExpiryDatePicker.open()">
              <input
                matInput
                (focus)="stayVisaExpiryDatePicker.open()"
                id="stayVisaExpiryDateInput"
                #applicantStayVisaExpiryDate
                [matDatepicker]="stayVisaExpiryDatePicker"
                placeholder="{{ 'PERSONAL_DATA_FORM.STAY-VISA-EXPIRY-DATE.PLACEHOLDER' | translate }}"
                [min]="minValidDate"
                [max]="maxValidFutureDate"
                [readonly]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="stayVisaExpiryDate.touched && stayVisaExpiryDate.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  stayVisaExpiryDate.touched && stayVisaExpiryDate.invalid ? 'stayVisaExpiryDateError' : null
                "
                [formControl]="stayVisaExpiryDate" />

              <mat-datepicker-toggle
                matSuffix
                [for]="stayVisaExpiryDatePicker"
                aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
              </mat-datepicker-toggle>

              <mat-datepicker
                #stayVisaExpiryDatePicker
                [startView]="'month'"
                [startAt]="'1985'"
                [calendarHeaderComponent]="pickerHeader"
                (closed)="applicantStayVisaExpiryDate.blur()">
              </mat-datepicker>

              <!-- ERROR -->
              <mat-error id="stayVisaExpiryDateError" *ngIf="stayVisaExpiryDate.touched && stayVisaExpiryDate.invalid">
                {{ stayVisaExpiryDate.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div
            *ngIf="controls.stayVisaPeriodOfStay as stayVisaPeriodOfStay"
            class="standard-form-field stayVisaPeriodOfStay-field required-field">
            <label
              for="stayVisaPeriodOfStayInput"
              [class.invalid]="stayVisaPeriodOfStay.touched && stayVisaPeriodOfStay.invalid">
              {{ 'PERSONAL_DATA_FORM.STAY-VISA-PERIOD-OF-STAY.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="stayVisaPeriodOfStayInput"
                type="number"
                min="1"
                max="9999"
                placeholder="{{ 'PERSONAL_DATA_FORM.STAY-VISA-PERIOD-OF-STAY.PLACEHOLDER' | translate }}"
                [formControl]="stayVisaPeriodOfStay"
                [attr.aria-required]="true"
                [attr.aria-invalid]="stayVisaPeriodOfStay.touched && stayVisaPeriodOfStay.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  stayVisaPeriodOfStay.touched && stayVisaPeriodOfStay.invalid ? 'stayVisaPeriodOfStayError' : null
                " />

              <!-- ERROR -->
              <mat-error
                id="stayVisaPeriodOfStayError"
                *ngIf="stayVisaPeriodOfStay.touched && stayVisaPeriodOfStay.invalid">
                {{ stayVisaPeriodOfStay.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div
            *ngIf="controls.stayVisaIssuingAuthority as stayVisaIssuingAuthority"
            class="standard-form-field stayVisaIssuingAuthority-field required-field">
            <label
              for="stayVisaIssuingAuthorityInput"
              [class.invalid]="stayVisaIssuingAuthority.touched && stayVisaIssuingAuthority.invalid">
              {{ 'PERSONAL_DATA_FORM.STAY-VISA-ISSUING-AUTHORITY.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="stayVisaIssuingAuthorityInput"
                type="text"
                minlength="1"
                maxlength="100"
                placeholder="{{ 'PERSONAL_DATA_FORM.STAY-VISA-ISSUING-AUTHORITY.PLACEHOLDER' | translate }}"
                [formControl]="stayVisaIssuingAuthority"
                [attr.aria-required]="true"
                [attr.aria-invalid]="
                  stayVisaIssuingAuthority.touched && stayVisaIssuingAuthority.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  stayVisaIssuingAuthority.touched && stayVisaIssuingAuthority.invalid
                    ? 'stayVisaIssuingAuthorityError'
                    : null
                " />

              <!-- ERROR -->
              <mat-error
                id="stayVisaIssuingAuthorityError"
                *ngIf="stayVisaIssuingAuthority.touched && stayVisaIssuingAuthority.invalid">
                {{ stayVisaIssuingAuthority.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="controls.legalBasisOfStay.value === 'SCHENGEN_COUNTRY_ISSUED_DOC'">
        <nz-divider [nzText]="travelers" nzOrientation="center">
          <ng-template #travelers>
            <h5>{{ 'PERSONAL_DATA_FORM.RESIDENCE_CARD_OR_DOCUMENT_AUTHORIZING' | translate }}</h5>
          </ng-template>
        </nz-divider>

        <div class="row">
          <div
            *ngIf="controls.stayEntitlingDocumentIssueDate as stayEntitlingDocumentIssueDate"
            class="standard-form-field stayEntitlingDocumentIssueDate-field required-field">
            <label
              for="stayEntitlingDocumentIssueDateInput"
              [class.invalid]="stayEntitlingDocumentIssueDate.touched && stayEntitlingDocumentIssueDate.invalid">
              {{ 'PERSONAL_DATA_FORM.STAY-VISA-ISSUE-DATE.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline" (click)="stayEntitlingDocumentIssueDatePicker.open()">
              <input
                matInput
                (focus)="stayEntitlingDocumentIssueDatePicker.open()"
                id="stayEntitlingDocumentIssueDateInput"
                #applicantStayEntitlingDocumentIssueDate
                [matDatepicker]="stayEntitlingDocumentIssueDatePicker"
                placeholder="{{ 'PERSONAL_DATA_FORM.STAY-VISA-ISSUE-DATE.PLACEHOLDER' | translate }}"
                [min]="minValidDate"
                [max]="maxValidDate"
                [readonly]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="
                  stayEntitlingDocumentIssueDate.touched && stayEntitlingDocumentIssueDate.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  stayEntitlingDocumentIssueDate.touched && stayEntitlingDocumentIssueDate.invalid
                    ? 'stayEntitlingDocumentIssueDateError'
                    : null
                "
                [formControl]="stayEntitlingDocumentIssueDate" />

              <mat-datepicker-toggle
                matSuffix
                [for]="stayEntitlingDocumentIssueDatePicker"
                aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
              </mat-datepicker-toggle>

              <mat-datepicker
                #stayEntitlingDocumentIssueDatePicker
                [startView]="'month'"
                [startAt]="'1985'"
                [calendarHeaderComponent]="pickerHeader"
                (closed)="applicantStayEntitlingDocumentIssueDate.blur()">
              </mat-datepicker>

              <!-- ERROR -->
              <mat-error
                id="stayEntitlingDocumentIssueDateError"
                *ngIf="stayEntitlingDocumentIssueDate.touched && stayEntitlingDocumentIssueDate.invalid">
                {{ stayEntitlingDocumentIssueDate.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div
            *ngIf="controls.stayEntitlingDocumentIssuedBy as stayEntitlingDocumentIssuedBy"
            class="standard-form-field widened-field stayEntitlingDocumentIssuedBy-field required-field">
            <label
              for="stayEntitlingDocumentIssuedByInput"
              [class.invalid]="stayEntitlingDocumentIssuedBy.touched && stayEntitlingDocumentIssuedBy.invalid">
              {{ 'PERSONAL_DATA_FORM.STAY-ENTITLING-DOCUMENT-ISSUED-BY.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="stayEntitlingDocumentIssuedByInput"
                type="text"
                minLength="1"
                maxLength="100"
                placeholder="{{ 'PERSONAL_DATA_FORM.STAY-ENTITLING-DOCUMENT-ISSUED-BY.PLACEHOLDER' | translate }}"
                [formControl]="stayEntitlingDocumentIssuedBy"
                [attr.aria-required]="true"
                [attr.aria-invalid]="
                  stayEntitlingDocumentIssuedBy.touched && stayEntitlingDocumentIssuedBy.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  stayEntitlingDocumentIssuedBy.touched && stayEntitlingDocumentIssuedBy.invalid
                    ? 'stayEntitlingDocumentIssuedByError'
                    : null
                " />

              <!-- ERROR -->
              <mat-error
                id="stayEntitlingDocumentIssuedByError"
                *ngIf="stayEntitlingDocumentIssuedBy.touched && stayEntitlingDocumentIssuedBy.invalid">
                {{ stayEntitlingDocumentIssuedBy.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </ng-container>

      <ng-container
        *ngIf="controls.legalBasisOfStay.value !== 'VISA' && controls.legalBasisOfStay.value !== 'VISA_FREE'">
        <nz-divider [nzText]="travelers2" nzOrientation="center">
          <ng-template #travelers2>
            <h5>{{ 'PERSONAL_DATA_FORM.RESIDENCE_CARD_OR_DOCUMENT_AUTHORIZING_2' | translate }}</h5>
          </ng-template>
        </nz-divider>

        <div class="row">
          <div
            *ngIf="controls.entryDocumentSeries as entryDocumentSeries"
            class="standard-form-field entryDocumentSeries-field">
            <label
              for="entryDocumentSeriesInput"
              [class.invalid]="entryDocumentSeries.touched && entryDocumentSeries.invalid">
              {{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-SERIES.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="entryDocumentSeriesInput"
                type="text"
                minLength="1"
                maxLength="2"
                placeholder="{{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-SERIES.PLACEHOLDER' | translate }}"
                [formControl]="entryDocumentSeries"
                [attr.aria-required]="false"
                [attr.aria-invalid]="entryDocumentSeries.touched && entryDocumentSeries.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  entryDocumentSeries.touched && entryDocumentSeries.invalid ? 'entryDocumentSeriesError' : null
                " />

              <!-- ERROR -->
              <mat-error
                id="entryDocumentSeriesError"
                *ngIf="entryDocumentSeries.touched && entryDocumentSeries.invalid">
                {{ entryDocumentSeries.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div
            *ngIf="controls.entryDocumentNumber as entryDocumentNumber"
            class="standard-form-field entryDocumentNumber-field">
            <label
              for="entryDocumentNumberInput"
              [class.invalid]="entryDocumentNumber.touched && entryDocumentNumber.invalid">
              {{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-NUMBER.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="entryDocumentNumberInput"
                type="text"
                minLength="1"
                maxLength="20"
                placeholder="{{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-NUMBER.PLACEHOLDER' | translate }}"
                [formControl]="entryDocumentNumber"
                [attr.aria-required]="false"
                [attr.aria-invalid]="entryDocumentNumber.touched && entryDocumentNumber.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  entryDocumentNumber.touched && entryDocumentNumber.invalid ? 'entryDocumentNumberError' : null
                " />

              <!-- ERROR -->
              <mat-error
                id="entryDocumentNumberError"
                *ngIf="entryDocumentNumber.touched && entryDocumentNumber.invalid">
                {{ entryDocumentNumber.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div
            *ngIf="controls.entryDocumentIssueDate as entryDocumentIssueDate"
            class="standard-form-field entryDocumentIssueDate-field">
            <label
              for="entryDocumentIssueDateInput"
              [class.invalid]="entryDocumentIssueDate.touched && entryDocumentIssueDate.invalid">
              {{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-ISSUE-DATE.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline" (click)="entryDocumentIssueDatePicker.open()">
              <input
                matInput
                (focus)="entryDocumentIssueDatePicker.open()"
                id="entryDocumentIssueDateInput"
                #applicantEntryDocumentIssueDate
                [matDatepicker]="entryDocumentIssueDatePicker"
                placeholder="{{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-ISSUE-DATE.PLACEHOLDER' | translate }}"
                [min]="minValidDate"
                [max]="maxValidDate"
                [readonly]="true"
                [attr.aria-required]="false"
                [attr.aria-invalid]="entryDocumentIssueDate.touched && entryDocumentIssueDate.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  entryDocumentIssueDate.touched && entryDocumentIssueDate.invalid
                    ? 'entryDocumentIssueDateError'
                    : null
                "
                [formControl]="entryDocumentIssueDate" />

              <mat-datepicker-toggle
                matSuffix
                [for]="entryDocumentIssueDatePicker"
                aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
              </mat-datepicker-toggle>

              <mat-datepicker
                #entryDocumentIssueDatePicker
                [startView]="'month'"
                [startAt]="'1985'"
                [calendarHeaderComponent]="pickerHeader"
                (closed)="applicantEntryDocumentIssueDate.blur()">
              </mat-datepicker>

              <!-- ERROR -->
              <mat-error
                id="entryDocumentIssueDateError"
                *ngIf="entryDocumentIssueDate.touched && entryDocumentIssueDate.invalid">
                {{ entryDocumentIssueDate.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div
            *ngIf="controls.entryDocumentExpiryDate as entryDocumentExpiryDate"
            class="standard-form-field entryDocumentExpiryDate-field">
            <label
              for="entryDocumentExpiryDateInput"
              [class.invalid]="entryDocumentExpiryDate.touched && entryDocumentExpiryDate.invalid">
              {{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-EXPIRY-DATE.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline" (click)="entryDocumentExpiryDatePicker.open()">
              <input
                matInput
                (focus)="entryDocumentExpiryDatePicker.open()"
                id="entryDocumentExpiryDateInput"
                #applicantEntryDocumentExpiryDate
                [matDatepicker]="entryDocumentExpiryDatePicker"
                placeholder="{{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-EXPIRY-DATE.PLACEHOLDER' | translate }}"
                [min]="minValidDate"
                [max]="maxValidFutureDate"
                [readonly]="true"
                [formControl]="entryDocumentExpiryDate"
                [attr.aria-required]="false"
                [attr.aria-invalid]="entryDocumentExpiryDate.touched && entryDocumentExpiryDate.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  entryDocumentExpiryDate.touched && entryDocumentExpiryDate.invalid
                    ? 'entryDocumentExpiryDateError'
                    : null
                " />

              <mat-datepicker-toggle
                matSuffix
                [for]="entryDocumentExpiryDatePicker"
                aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
              </mat-datepicker-toggle>

              <mat-datepicker
                #entryDocumentExpiryDatePicker
                [startView]="'month'"
                [startAt]="'1985'"
                [calendarHeaderComponent]="pickerHeader"
                (closed)="applicantEntryDocumentExpiryDate.blur()">
              </mat-datepicker>

              <!-- ERROR -->
              <mat-error
                id="entryDocumentExpiryDateError"
                *ngIf="entryDocumentExpiryDate.touched && entryDocumentExpiryDate.invalid">
                {{ entryDocumentExpiryDate.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div
            *ngIf="controls.entryDocumentIssuingAuthority as entryDocumentIssuingAuthority"
            class="standard-form-field widened-field entryDocumentIssuingAuthority-field">
            <label
              for="entryDocumentIssuingAuthorityInput"
              [class.invalid]="entryDocumentIssuingAuthority.touched && entryDocumentIssuingAuthority.invalid">
              {{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-ISSUING-AUTHORITY.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="entryDocumentIssuingAuthorityInput"
                type="text"
                minLength="1"
                maxLength="100"
                placeholder="{{ 'PERSONAL_DATA_FORM.ENTRY-DOCUMENT-ISSUING-AUTHORITY.PLACEHOLDER' | translate }}"
                [formControl]="entryDocumentIssuingAuthority"
                [attr.aria-required]="false"
                [attr.aria-invalid]="
                  entryDocumentIssuingAuthority.touched && entryDocumentIssuingAuthority.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  entryDocumentIssuingAuthority.touched && entryDocumentIssuingAuthority.invalid
                    ? 'entryDocumentIssuingAuthorityError'
                    : null
                " />

              <!-- ERROR -->
              <mat-error
                id="entryDocumentIssuingAuthorityError"
                *ngIf="entryDocumentIssuingAuthority.touched && entryDocumentIssuingAuthority.invalid">
                {{ entryDocumentIssuingAuthority.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <nz-divider [nzText]="staysInPoland" nzOrientation="center">
      <ng-template #staysInPoland>
        <h5>{{ 'PERSONAL_DATA_FORM.STAYS_IN_POLAND' | translate }}</h5>
      </ng-template>
    </nz-divider>

    <div class="row">
      <div
        *ngIf="controls.noPreviousVisits as noPreviousVisits"
        class="standard-form-field radio-form-field noPreviousVisits-field required-field">
        <label id="noPreviousVisitsLabel" [class.invalid]="noPreviousVisits.touched && noPreviousVisits.invalid">
          {{ 'PERSONAL_DATA_FORM.NO-PREVIOUS-VISITS.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-radio-group
          id="noPreviousVisits"
          aria-labelledby="noPreviousVisitsLabel"
          formControlName="noPreviousVisits"
          [required]="true"
          [attr.aria-invalid]="noPreviousVisits.touched && noPreviousVisits.invalid ? 'true' : null">
          <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
          <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div class="row visits-row" *ngIf="controls.noPreviousVisits.value === false">
      <div
        *ngIf="controls.previousVisitsArr as previousVisitsArr"
        class="standard-form-field widened-field required-field">
        <label [class.invalid]="previousVisitsArr.touched && previousVisitsArr.invalid">
          {{ 'PERSONAL_DATA_FORM.PLEASE_LIST_ALL_YOUR_STAYS' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
      </div>
      <app-previous-visits-form-long-resi
        [previousVisitsArrFc]="controls.previousVisitsArr"
        [inPolandAtApplicationSubmition]="controls.inPolandAtApplicationSubmition"
        [lastEntryDateFc]="controls.lastEntryDate"
        [legalBasisOfStayFc]="controls.legalBasisOfStay"
        [legalBasisOfStayCommentFc]="controls.legalBasisOfStayComment"
        [currentlyLivingInPolandFc]="controls.currentlyLivingInPoland">
      </app-previous-visits-form-long-resi>
    </div>

    <div class="row">
      <div
        *ngIf="controls.noLastTravelsOutsidePoland as noLastTravelsOutsidePoland"
        class="standard-form-field radio-form-field noLastTravelsOutsidePoland-field required-field">
        <label
          id="noLastTravelsOutsidePolandLabel"
          [class.invalid]="noLastTravelsOutsidePoland.touched && noLastTravelsOutsidePoland.invalid">
          {{ 'PERSONAL_DATA_FORM.LAST-TRAVELS-OUTSIDE-POLAND.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <!-- IMPORTANT about noLastTravelsOutsidePoland
            there is fuckup because of different label text!
            the field is 'noLastTravelsOutsidePoland' so it would mean that
            if noLastTravelsOutsidePoland === true then user DID NOT have any travels outside poland.
            BUT! !IMPORTANT! current label for this field is: 'Czy przekraczałeś granice krajów innych niż Polska w przeciągu ostatnich 5 lat?'
            so if user marks YES then it means that we have to set our field value to `false` as user DID HAVE TRAVELS OUTSIDE POLAND
          -->
        <mat-radio-group
          id="noLastTravelsOutsidePoland"
          aria-labelledby="noLastTravelsOutsidePolandLabel"
          formControlName="noLastTravelsOutsidePoland"
          [required]="true"
          [attr.aria-invalid]="
            noLastTravelsOutsidePoland.touched && noLastTravelsOutsidePoland.invalid ? 'true' : null
          ">
          <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
          <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
      <cr-button
        *ngIf="controls.noLastTravelsOutsidePoland.value === false && visitsAmount > 1 && mode === 'employee'"
        class="sort-button"
        [isLoading]="isVisitsSorting"
        [isDisabled]="isVisitsLoading"
        (clicked)="sortClick$.next()">
        {{ 'COUNTRIES_VISITS_FORM.SORT_VISITS' | translate }}
      </cr-button>
    </div>

    <div class="row visits-row" *ngIf="controls.noLastTravelsOutsidePoland.value === false">
      <div
        *ngIf="controls.lastTravelsOutsidePoland as lastTravelsOutsidePoland"
        class="standard-form-field widened-field required-field">
        <label [class.invalid]="lastTravelsOutsidePoland.touched && lastTravelsOutsidePoland.invalid">
          {{ 'PERSONAL_DATA_FORM.PLEASE_LIST_ALL_YOUR_TRAVELS' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
      </div>
      <app-countries-visits-form-long-resi
        [lastTravelsOutsidePoland]="controls.lastTravelsOutsidePoland"
        [triggerSort]="sortClick$"
        (sortingChanged)="onVisitsSortingChange($event)"
        (loadingChanged)="onVisitsLoadingChange($event)">
      </app-countries-visits-form-long-resi>
    </div>

    <div class="row">
      <div
        *ngIf="controls.hasBlueCardStaysInEU as hasBlueCardStaysInEU"
        class="standard-form-field radio-form-field hasBlueCardStaysInEU-field required-field">
        <label
          id="hasBlueCardStaysInEULabel"
          [class.invalid]="hasBlueCardStaysInEU.touched && hasBlueCardStaysInEU.invalid">
          {{ 'PERSONAL_DATA_FORM.HAVE-BLUE-CARD-STAYS-IN-EU-BOOLEAN.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-radio-group
          id="hasBlueCardStaysInEU"
          aria-labelledby="hasBlueCardStaysInEULabel"
          formControlName="hasBlueCardStaysInEU"
          [required]="true"
          [attr.aria-invalid]="hasBlueCardStaysInEU.touched && hasBlueCardStaysInEU.invalid ? 'true' : null">
          <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
          <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <ng-container *ngIf="controls.hasBlueCardStaysInEU.value === true">
      <div class="row">
        <div
          *ngIf="controls.blueCardStaysInEU as blueCardStaysInEU"
          class="standard-form-field three-fourth-field blueCardStaysInEU-field radio-form-field required-field">
          <label for="blueCardStaysInEUInput" [class.invalid]="blueCardStaysInEU.touched && blueCardStaysInEU.invalid">
            {{ 'PERSONAL_DATA_FORM.HAVE-BLUE-CARD-STAYS-IN-EU.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="6"
              id="blueCardStaysInEUInput"
              type="text"
              minLength="1"
              maxLength="9999"
              placeholder=""
              [formControl]="blueCardStaysInEU"
              [attr.aria-required]="true"
              [attr.aria-invalid]="blueCardStaysInEU.touched && blueCardStaysInEU.invalid ? 'true' : null"
              [attr.aria-describedby]="
                blueCardStaysInEU.touched && blueCardStaysInEU.invalid ? 'blueCardStaysInEUError' : null
              "></textarea>

            <!-- ERROR -->
            <mat-error id="blueCardStaysInEUError" *ngIf="blueCardStaysInEU.touched && blueCardStaysInEU.invalid">
              {{ blueCardStaysInEU.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </ng-container>

    <div class="row">
      <div
        *ngIf="controls.hasScientistStaysInEU as hasScientistStaysInEU"
        class="standard-form-field radio-form-field hasScientistStaysInEU-field required-field">
        <label
          id="hasScientistStaysInEULabel"
          [class.invalid]="hasScientistStaysInEU.touched && hasScientistStaysInEU.invalid">
          {{ 'PERSONAL_DATA_FORM.HAVE-SCIENTIST-STAYS-IN-EU-BOOLEAN.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-radio-group
          id="hasScientistStaysInEU"
          aria-labelledby="hasScientistStaysInEULabel"
          formControlName="hasScientistStaysInEU"
          [required]="true"
          [attr.aria-invalid]="hasScientistStaysInEU.touched && hasScientistStaysInEU.invalid ? 'true' : null">
          <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
          <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <ng-container *ngIf="controls.hasScientistStaysInEU.value === true">
      <div class="row">
        <div
          *ngIf="controls.scientistStaysInEU as scientistStaysInEU"
          class="standard-form-field three-fourth-field scientistStaysInEU-field radio-form-field required-field">
          <label
            for="scientistStaysInEUInput"
            [class.invalid]="scientistStaysInEU.touched && scientistStaysInEU.invalid">
            {{ 'PERSONAL_DATA_FORM.HAVE-SCIENTIST-STAYS-IN-EU.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="6"
              id="scientistStaysInEUInput"
              type="text"
              minLength="1"
              maxLength="9999"
              placeholder=""
              [formControl]="scientistStaysInEU"
              [attr.aria-required]="true"
              [attr.aria-invalid]="scientistStaysInEU.touched && scientistStaysInEU.invalid ? 'true' : null"
              [attr.aria-describedby]="
                scientistStaysInEU.touched && scientistStaysInEU.invalid ? 'scientistStaysInEUError' : null
              "></textarea>

            <!-- ERROR -->
            <mat-error id="scientistStaysInEUError" *ngIf="scientistStaysInEU.touched && scientistStaysInEU.invalid">
              {{ scientistStaysInEU.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </ng-container>

    <div class="row">
      <div
        *ngIf="controls.hasInternationalProtectionStaysInEU as hasInternationalProtectionStaysInEU"
        class="standard-form-field radio-form-field hasInternationalProtectionStaysInEU-field required-field">
        <label
          id="hasInternationalProtectionStaysInEULabel"
          [class.invalid]="hasInternationalProtectionStaysInEU.touched && hasInternationalProtectionStaysInEU.invalid">
          {{ 'PERSONAL_DATA_FORM.HAVE-INTERNATIONAL-PROTECTION-STAYS-IN-EU-BOOLEAN.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-radio-group
          id="hasInternationalProtectionStaysInEU"
          aria-labelledby="hasInternationalProtectionStaysInEULabel"
          formControlName="hasInternationalProtectionStaysInEU"
          [required]="true"
          [attr.aria-invalid]="
            hasInternationalProtectionStaysInEU.touched && hasInternationalProtectionStaysInEU.invalid ? 'true' : null
          ">
          <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
          <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <ng-container *ngIf="controls.hasInternationalProtectionStaysInEU.value === true">
      <div class="row">
        <div
          *ngIf="controls.internationalProtectionStaysInEU as internationalProtectionStaysInEU"
          class="standard-form-field three-fourth-field internationalProtectionStaysInEU-field radio-form-field required-field">
          <label
            for="internationalProtectionStaysInEUInput"
            [class.invalid]="internationalProtectionStaysInEU.touched && internationalProtectionStaysInEU.invalid">
            {{ 'PERSONAL_DATA_FORM.HAVE-INTERNATIONAL-PROTECTION-STAYS-IN-EU.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="6"
              id="internationalProtectionStaysInEUInput"
              type="text"
              minLength="1"
              maxLength="9999"
              placeholder=""
              [formControl]="internationalProtectionStaysInEU"
              [attr.aria-required]="true"
              [attr.aria-invalid]="
                internationalProtectionStaysInEU.touched && internationalProtectionStaysInEU.invalid ? 'true' : null
              "
              [attr.aria-describedby]="
                internationalProtectionStaysInEU.touched && internationalProtectionStaysInEU.invalid
                  ? 'internationalProtectionStaysInEUError'
                  : null
              "></textarea>

            <!-- ERROR -->
            <mat-error
              id="internationalProtectionStaysInEUError"
              *ngIf="internationalProtectionStaysInEU.touched && internationalProtectionStaysInEU.invalid">
              {{ internationalProtectionStaysInEU.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </ng-container>

    <div class="row">
      <div
        *ngIf="controls.hasHighQualificationsStaysInEU as hasHighQualificationsStaysInEU"
        class="standard-form-field radio-form-field hasHighQualificationsStaysInEU-field required-field">
        <label
          id="hasHighQualificationsStaysInEULabel"
          [class.invalid]="hasHighQualificationsStaysInEU.touched && hasHighQualificationsStaysInEU.invalid">
          {{ 'PERSONAL_DATA_FORM.HAVE-HIGH-QUALIFICATIONS-STAYS-IN-EU-BOOLEAN.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-radio-group
          id="hasHighQualificationsStaysInEU"
          aria-labelledby="hasHighQualificationsStaysInEULabel"
          formControlName="hasHighQualificationsStaysInEU"
          [required]="true"
          [attr.aria-invalid]="
            hasHighQualificationsStaysInEU.touched && hasHighQualificationsStaysInEU.invalid ? 'true' : null
          ">
          <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
          <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <ng-container *ngIf="controls.hasHighQualificationsStaysInEU.value === true">
      <div class="row">
        <div
          *ngIf="controls.highQualificationsStaysInEU as highQualificationsStaysInEU"
          class="standard-form-field three-fourth-field highQualificationsStaysInEU-field radio-form-field required-field">
          <label
            for="highQualificationsStaysInEUInput"
            [class.invalid]="highQualificationsStaysInEU.touched && highQualificationsStaysInEU.invalid">
            {{ 'PERSONAL_DATA_FORM.HAVE-HIGH-QUALIFICATIONS-STAYS-IN-EU.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="6"
              id="highQualificationsStaysInEUInput"
              type="text"
              minLength="1"
              maxLength="9999"
              placeholder=""
              [formControl]="highQualificationsStaysInEU"
              [attr.aria-required]="true"
              [attr.aria-invalid]="
                highQualificationsStaysInEU.touched && highQualificationsStaysInEU.invalid ? 'true' : null
              "
              [attr.aria-describedby]="
                highQualificationsStaysInEU.touched && highQualificationsStaysInEU.invalid
                  ? 'highQualificationsStaysInEUError'
                  : null
              "></textarea>

            <!-- ERROR -->
            <mat-error
              id="highQualificationsStaysInEUError"
              *ngIf="highQualificationsStaysInEU.touched && highQualificationsStaysInEU.invalid">
              {{ highQualificationsStaysInEU.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </ng-container>

    <div class="row">
      <div
        *ngIf="controls.hasStudentStaysInEU as hasStudentStaysInEU"
        class="standard-form-field radio-form-field hasStudentStaysInEU-field required-field">
        <label
          id="hasStudentStaysInEULabel"
          [class.invalid]="hasStudentStaysInEU.touched && hasStudentStaysInEU.invalid">
          {{ 'PERSONAL_DATA_FORM.HAVE-STUDENT-STAYS-IN-EU-BOOLEAN.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-radio-group
          id="hasStudentStaysInEU"
          aria-labelledby="hasStudentStaysInEULabel"
          formControlName="hasStudentStaysInEU"
          [required]="true"
          [attr.aria-invalid]="hasStudentStaysInEU.touched && hasStudentStaysInEU.invalid ? 'true' : null">
          <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
          <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <ng-container *ngIf="controls.hasStudentStaysInEU.value === true">
      <div class="row">
        <div
          *ngIf="controls.studentStaysInEU as studentStaysInEU"
          class="standard-form-field three-fourth-field studentStaysInEU-field radio-form-field required-field">
          <label for="studentStaysInEUInput" [class.invalid]="studentStaysInEU.touched && studentStaysInEU.invalid">
            {{ 'PERSONAL_DATA_FORM.HAVE-STUDENT-STAYS-IN-EU.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="6"
              id="studentStaysInEUInput"
              type="text"
              minLength="1"
              maxLength="9999"
              placeholder=""
              [formControl]="studentStaysInEU"
              [attr.aria-required]="true"
              [attr.aria-invalid]="studentStaysInEU.touched && studentStaysInEU.invalid ? 'true' : null"
              [attr.aria-describedby]="
                studentStaysInEU.touched && studentStaysInEU.invalid ? 'studentStaysInEUError' : null
              "></textarea>

            <!-- ERROR -->
            <mat-error id="studentStaysInEUError" *ngIf="studentStaysInEU.touched && studentStaysInEU.invalid">
              {{ studentStaysInEU.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </ng-container>

    <div class="row">
      <div
        *ngIf="controls.hasTravelsWithBlueCardStaysInEU as hasTravelsWithBlueCardStaysInEU"
        class="standard-form-field radio-form-field hasTravelsWithBlueCardStaysInEU-field required-field">
        <label
          id="hasTravelsWithBlueCardStaysInEULabel"
          [class.invalid]="hasTravelsWithBlueCardStaysInEU.touched && hasTravelsWithBlueCardStaysInEU.invalid">
          {{ 'PERSONAL_DATA_FORM.HAVE-TRAVELS-WITH-BLUE-CARD-STAYS-IN-EU-BOOLEAN.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-radio-group
          id="hasTravelsWithBlueCardStaysInEU"
          aria-labelledby="hasTravelsWithBlueCardStaysInEULabel"
          formControlName="hasTravelsWithBlueCardStaysInEU"
          [required]="true"
          [attr.aria-invalid]="
            hasTravelsWithBlueCardStaysInEU.touched && hasTravelsWithBlueCardStaysInEU.invalid ? 'true' : null
          ">
          <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
          <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <ng-container *ngIf="controls.hasTravelsWithBlueCardStaysInEU.value === true">
      <div class="row">
        <div
          *ngIf="controls.travelsWithBlueCardStaysInEU as travelsWithBlueCardStaysInEU"
          class="standard-form-field three-fourth-field travelsWithBlueCardStaysInEU-field radio-form-field required-field">
          <label
            for="travelsWithBlueCardStaysInEUInput"
            [class.invalid]="travelsWithBlueCardStaysInEU.touched && travelsWithBlueCardStaysInEU.invalid">
            {{ 'PERSONAL_DATA_FORM.HAVE-TRAVELS-WITH-BLUE-CARD-STAYS-IN-EU.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="6"
              id="travelsWithBlueCardStaysInEUInput"
              type="text"
              minLength="1"
              maxLength="9999"
              placeholder=""
              [formControl]="travelsWithBlueCardStaysInEU"
              [attr.aria-required]="true"
              [attr.aria-invalid]="
                travelsWithBlueCardStaysInEU.touched && travelsWithBlueCardStaysInEU.invalid ? 'true' : null
              "
              [attr.aria-describedby]="
                travelsWithBlueCardStaysInEU.touched && travelsWithBlueCardStaysInEU.invalid
                  ? 'travelsWithBlueCardStaysInEUError'
                  : null
              "></textarea>

            <!-- ERROR -->
            <mat-error
              id="travelsWithBlueCardStaysInEUError"
              *ngIf="travelsWithBlueCardStaysInEU.touched && travelsWithBlueCardStaysInEU.invalid">
              {{ travelsWithBlueCardStaysInEU.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </ng-container>

    <div class="row">
      <div
        *ngIf="controls.hasOtherLongTermPermits as hasOtherLongTermPermits"
        class="standard-form-field radio-form-field hasOtherLongTermPermits-field required-field">
        <label
          id="hasOtherLongTermPermitsLabel"
          [class.invalid]="hasOtherLongTermPermits.touched && hasOtherLongTermPermits.invalid">
          {{ 'PERSONAL_DATA_FORM.OTHER-LONG-TERM-PERMITS-BOOLEAN.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-radio-group
          id="hasOtherLongTermPermits"
          aria-labelledby="hasOtherLongTermPermitsLabel"
          formControlName="hasOtherLongTermPermits"
          (keydown.Tab)="controls.hasOtherLongTermPermits.value === true ? undefined : emitLastFieldTabPressed($event)"
          [required]="true"
          [attr.aria-invalid]="hasOtherLongTermPermits.touched && hasOtherLongTermPermits.invalid ? 'true' : null">
          <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
          <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <ng-container *ngIf="controls.hasOtherLongTermPermits.value === true">
      <div class="row">
        <div
          *ngIf="controls.otherLongTermPermits as otherLongTermPermits"
          class="standard-form-field three-fourth-field otherLongTermPermits-field radio-form-field required-field">
          <label
            for="otherLongTermPermitsInput"
            [class.invalid]="otherLongTermPermits.touched && otherLongTermPermits.invalid">
            {{ 'PERSONAL_DATA_FORM.OTHER-LONG-TERM-PERMITS.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="6"
              id="otherLongTermPermitsInput"
              type="text"
              minLength="1"
              maxLength="9999"
              placeholder=""
              [formControl]="otherLongTermPermits"
              [attr.aria-required]="true"
              [attr.aria-invalid]="otherLongTermPermits.touched && otherLongTermPermits.invalid ? 'true' : null"
              [attr.aria-describedby]="
                otherLongTermPermits.touched && otherLongTermPermits.invalid ? 'otherLongTermPermitsError' : null
              "
              (keydown.Tab)="lastFieldTabPressed.emit(); $event.preventDefault(); $event.stopPropagation()">
            </textarea>

            <!-- ERROR -->
            <mat-error
              id="otherLongTermPermitsError"
              *ngIf="otherLongTermPermits.touched && otherLongTermPermits.invalid">
              {{ otherLongTermPermits.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </div>
</form>
